import axiosBase from "@/api/axiosBase";

const state = {
  subbasinStep1_data: "",
  subbasinStep2_data: "",
  subbasinStep2_extract_data: "",
  SlopeRawdata_data: "",
  slopeClassify_data: "",
  landuseSoilRawdata_data: "",
  landuseSoilClassify_data: "",
  infiltClassify_data: "",
  hruRawdata_data: "",
  hruClassify_data: "",
  modelMake_data: "",
  autoBuild_data: "",
  tifFile: "",
  deleteResult: "",
  basinHru: "",
  checkData: "",
};
const getters = {};

const mutations = {
  // 子流域划分第一步
  setSubbasinStep1(state, data) {
    state.subbasinStep1_data = data;
  },
  // 子流域划分第二步
  setSubbasinStep2(state, data) {
    state.subbasinStep2_data = data;
  },
  // 子流域划分第二步
  setSubbasinStep2_extract(state, data) {
    state.subbasinStep2_extract_data = data;
  },

  // 生成地形坡度
  setSlopeRawdata(state, data) {
    state.SlopeRawdata_data = data;
  },
  // 地形坡度分类
  setSlopeClassify(state, data) {
    state.slopeClassify_data = data;
  },
  // 土地利用/土壤原始数据
  setLanduseSoilRawdata(state, data) {
    state.landuseSoilRawdata_data = data;
  },
  // 土地利用/土壤重分类
  setLanduseSoilClassify(state, data) {
    state.landuseSoilClassify_data = data;
  },
  // 土壤渗透性分类
  setInfiltClassify(state, data) {
    state.infiltClassify_data = data;
  },
  // HRU生成原始数据
  setHruRawdata(state, data) {
    state.hruRawdata_data = data;
  },
  // HRU重分类
  setHruRawdata(state, data) {
    state.hruClassify_data = data;
  },
  // 生成模型
  setModelMake(state, data) {
    state.modelMake_data = data;
  },
  // 气象数据自动处理
  setAutoBuild(state, data) {
    state.autoBuild_data = data;
  },

  setTifFile(state, data) {
    state.tifFile = data;
  },

  setDeleteResult(state, data) {
    state.deleteResult = data;
  },

  setBasinHru(state, data) {
    state.basinHru = data;
  },

  setCheckData(state, data) {
    state.checkData = data;
  },
};

const actions = {
  // 子流域划分第一步
  subbasinStep1({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/model/build/subbasin_step1",
        data: {
          crop_xmax: data.crop_xmax,
          crop_xmin: data.crop_xmin,
          crop_ymax: data.crop_ymax,
          crop_ymin: data.crop_ymin,
          lake_shp: data.lake_shp,
          min_area: data.min_area,
          model_id: data.model_id,
          obspt_shp: data.obspt_shp,
          river_shp: data.river_shp,
          // "start_task": data.start_task,
          // "timeout": 0
        },
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true },
            );
          } else {
            commit("setSubbasinStep1", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true },
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 子流域划分第二步
  subbasinStep2({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/model/build/subbasin_step2",
        data: {
          model_id: data.model_id,
          outlet_x: data.outlet_x,
          outlet_y: data.outlet_y,
        },
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true },
            );
          } else {
            commit("setSubbasinStep2", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true },
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 子流域划分第二步(新版)
  subbasinStep2_extract({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/model/build/subbasin_extract",
        data: {
          model_id: data.model_id,
          subids: data.selected,
        },
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true },
            );
          } else {
            commit("setSubbasinStep2_extract", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true },
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 生成地形坡度
  slopeRawdata({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/model/build/slope_rawdata",
        data: {
          model_id: data.model_id,
        },
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true },
            );
          } else {
            commit("setSlopeRawdata", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true },
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 地形坡度分类
  slopeClassify({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/model/build/slope_classify",
        data: {
          group_name: data.group_name,
          group_split: data.group_split,
          model_id: data.model_id,
        },
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true },
            );
          } else {
            commit("setSlopeClassify", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true },
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 土地利用/土壤原始数据
  landuseSoilRawdata({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/model/build/landuse_soil_rawdata",
        data: {
          is_soil: data.is_soil,
          model_id: data.model_id,
          use_infilt: data.use_infilt,
        },
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true },
            );
          } else {
            commit("setLanduseSoilRawdata", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true },
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 土地利用/土壤重分类
  landuseSoilClassify({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/model/build/landuse_soil_classify",
        data: {
          is_soil: data.is_soil,
          model_id: data.model_id,
          reclass: data.reclass,
        },
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true },
            );
          } else {
            commit("setLanduseSoilClassify", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true },
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 土壤渗透性分类
  infiltSoilClassify({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/model/build/infilt_classify",
        data: {
          group_name: data.group_name,
          group_split: data.group_split,
          model_id: data.model_id,
        },
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true },
            );
          } else {
            commit("setInfiltClassify", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true },
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // HRU生成原始数据
  hruRawdata({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/model/build/hru_rawdata",
        data: {
          model_id: data.model_id,
        },
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true },
            );
          } else {
            commit("setHruRawdata", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true },
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // HRU重分类
  hruClassify({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/model/build/hru_classify",
        data: {
          model_id: data.model_id,
          reclass: data.reclass,
        },
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true },
            );
          } else {
            commit("setHruRawdata", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true },
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 生成模型
  modelMake({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/model/build/model_make",
        data: {
          model_id: data.model_id,
          start_date: data.start_date,
          end_date: data.end_date,
          modules: data.modules,
          qual_mapping: data.qual_mapping,
          hru_mapping: data.hru_mapping,
        },
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true },
            );
          } else {
            commit("setModelMake", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true },
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 气象数据自动处理
  autoBuild({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/model/metero/auto_build",
        data: {
          model_id: data.model_id,
          sdate: data.sdate,
          edate: data.edate,
          file_ids: data.file_ids,
        },
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true },
            );
          } else {
            commit("setAutoBuild", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true },
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 获取tif文件
  getTifFile({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "GET",
        url: "/basedata/tif/" + data.fileId,
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true },
            );
          } else {
            commit("setTifFile", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true },
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 删除之前的快速建模结果
  deleteResult({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/model/build/delete",
        data: {
          model_id: data.model_id,
          step: data.step,
        },
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true },
            );
          } else {
            commit("setDeleteResult", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true },
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 获取basin_hru.csv文件中的hru
  getBasinHru({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "GET",
        url: "/model/build/subbasin_hru_get" + "?model_id=" + data.modelId,
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true },
            );
          } else {
            commit("setBasinHru", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true },
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 检查输入数据的合理性
  checkData({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/model/build/check_data",
        data: {
          data_type: data.data_type,
          file_path: data.file_path,
          model_id: data.model_id,
        },
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true },
            );
          } else {
            commit("setCheckData", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true },
          );
          resolve({ data: { code: 500 } });
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
